import React, { useEffect, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { JobDetail } from "pages/c-dad-user-data";
import SelectAnalysisType from "./components/selectAnalysisType";
import { AGGREGATIONDATALIST, AGGREGATIONVALUEEDISCRETEEXCLUDELIST, AnalysisTypeList } from "utility/constants";
import HistogramVisualization from "./components/Histogram";
import BarchartDataVisualization from "./components/BarChart";
import TimeSeriesVisualization from "./components/TimeSeries";
import HistogramIcon from "assets/histogramIcon";
import DoublePlotHistogramVisualization from "./components/DoublePlotHistogram";
import { autoCompleteSelectOptionsFormat, /*generateTimeSeriesData,*/ getAggreListHeatMap, getFilterKeyData, getJobType, getLatLongPositionData, getUserInputStringData, selectedListValues, sortJobAuditList, /*getHeaderValuesFromArray*/ } from "utility/helper";
import HeatMapVisualization from "./components/HeatMap";
import MultiSelectAutoComplete, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple";
import { listItemProp } from "utility/types";
import QuadPlotHistogramVisualization from "./components/QuadPlotHistogram";
import { toast } from "react-toastify";
import PieChartVisualization from "./components/PieChart";
import ScatterPlotVisualization from "./components/ScatterPlot";
import { MapViewSVG } from "assets/mapViewSVG";
import { useLocation } from "react-router";

import Geofence from "shared-component/geo-filter";
import { useStyles } from "./style";
import { histoGramData } from "assets/DataFile/headerPageData";

interface FillPageProps {
  userInputData: Array<string>, jobDetails: JobDetail[], vinListTimeSeries: string[], subJobs?: any,
  headerJobId: string;
  filteredVinListData?: any;
  requestTimeListTimeSeries?: any;
}

const DataVisualization = (props: FillPageProps) => {
  console.log('ppeppepe', props)
  const dataa: any = {}
  const { cDadDataVisualizationData, /*linkCdadFilterAttributes*/ linkCdadMapFilterAttributes } = dataa
  const { userInputData, jobDetails, vinListTimeSeries, subJobs, requestTimeListTimeSeries, /*filteredVinListData*/ } = props;
  console.log('userInputData, jobDetails, vinListTimeSeries, subJobs, requestTimeListTimeSeries', userInputData, jobDetails, vinListTimeSeries, subJobs, requestTimeListTimeSeries)
  const theme = useTheme();
  const [singnalListData, setSingnalListData] = useState<string[]>([]);
  const [, setJobID] = useState<string>(jobDetails[1].value);
  const [dataType, setDataType] = useState('raw');
  const [aggregateType, setAggregateType] = useState<string[]>([]);
  const [groupBy, setGroupBy] = useState<string[]>([]);
  const [data, setData] = useState<any>();
  const [analysisValue, setAnalysisValue] = useState('histogram');
  const [, setaggregateList] = useState<string[]>([]);
  const [showApply, setShowApply] = useState<boolean>(false);
  const prepDataExist = subJobs?.filter((elemnet: any) => elemnet.status === 'Success' && getJobType(elemnet?.user_inputs) === 'Prepared Data')
  const currentSJob = prepDataExist ? sortJobAuditList(prepDataExist)[0] : null;
  const preparedDataAggregation: string[] = currentSJob ? getUserInputStringData(currentSJob.user_inputs, 'aggregation') : [];
  const preparedDataGroupBy: string[] = currentSJob ? getUserInputStringData(currentSJob.user_inputs, 'groupBy') : [];
  const preparedDataSignalOld: string[] = currentSJob ? getUserInputStringData(currentSJob.user_inputs, 'agg_signals') : [];
  const preparedDataAggregationSignal: string[] = currentSJob ? getUserInputStringData(currentSJob.user_inputs, 'signals') : [];
  const style = useStyles();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const routeLocation = useLocation();
  const { /*linkCdadFilterAttributesData*/ linkCdadMapFilterAttributesData } = routeLocation.state;
  const [/*mapData*/, setMapData] = useState(linkCdadMapFilterAttributesData?.mapView_data ?? []);
  const [/*goeCoordinates*/, setGoeCoordinates] = useState([]);
  const [/*goeBondValue*/, setGoeBondValue] = useState("");
  const [/*isLatLangNotValid*/, setisLatLangNotValid] = useState<boolean>(false);
  
  const [selectedVINs, setSelectedVINs] = useState<string[]>([]);
  const handleVINSelection = (selectedVINs: string[]) => { 
    setSelectedVINs(selectedVINs);
  };

  const updateCoordinates = (value: any) => {
    setGoeCoordinates(value);
  };

  const updateBondValue = (value: string) => {
    setGoeBondValue(value);
  };


useEffect(() => {
    //const filterDataPayload = selectedVINs.length > 0 ? { vins: selectedVINs } : false;
    setMapData(linkCdadMapFilterAttributes?.mapView_data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedVINs]);

  const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });


  const onApply = () => {
    if (singnalListData?.length > 0 && aggregateType?.length > 0) {
      switch (analysisValue) {
        case 'histogram':
          console.log('histogram')
          break;
        case 'doubleplot':
          console.log('doubleplot')
          break;
        case 'quadplot':
          handleQuadPlotApply()
          break;
        case 'barchart':
          updateBarChartFilter({ signal: singnalListData, groupBy: groupBy, aggregation: aggregateType })
          break;
        case 'piechart':
          updatePieChartFilter({ signal: singnalListData, groupBy: groupBy, aggregation: aggregateType[0] });
          break;
        default:
          break
      }
    }
  };

  const handleQuadPlotApply = () => {
    if(singnalListData?.length < 4 || (singnalListData?.length > 4 && singnalListData?.length < 8) || singnalListData?.length > 8) {
      toast.warning('Please select 4 or 8 Signals');
    } 
  }

  useEffect(() => {
    setAggregateType([]);
    setGroupBy([]);
    setData(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analysisValue, dataType])

  const updateBarChartFilter = (value: any) => {
   console.log('update bar chart')
  }

  const updateHeatMapFilter = (value: any) => {
    console.log('update heat chart') 
  }

  const updatePieChartFilter = (value: any) => {
    console.log('update heat chart') 
  }

  const updateScatterPLotFilter = (value: any) => {
    const { vinList, signalList} = value;
    if (vinList?.length > 0 && signalList?.length > 0) {
      console.log('update heat chart') 
  }

  }

  const updateTimeSeriesFilter = (value: any) => {
    const { vinList, signalList } = value;
    if (vinList?.length > 0 && signalList?.length > 0) {
      console.log('update heat chart') 
  }

  }

  const handleSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setSingnalListData(
      value
    );
  }

  useEffect(() => {
    if ((analysisValue === 'histogram' || analysisValue === 'doubleplot' || analysisValue === 'quadplot')) {
      setShowApply(true)
    } else {
      setShowApply(false)
    }
  }, [cDadDataVisualizationData, analysisValue])

  useEffect(() => {
    let jobid = currentSJob && currentSJob.id ? currentSJob.id : jobDetails[1].value;
    if (analysisValue === 'timeseries') {
      if (dataType === 'raw') {
        jobid = jobDetails[1].value
      } else {
        jobid = prepDataExist[0].id;
      }
    }
    setJobID(jobid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataType, analysisValue])

  const handleMapViewClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const signalList = preparedDataAggregationSignal?.length > 0 ? preparedDataAggregationSignal : preparedDataSignalOld?.length > 0 ? preparedDataSignalOld : userInputData;
  const aggregateList = preparedDataAggregation?.length > 0 ? getAggreListHeatMap(preparedDataAggregation) : AGGREGATIONVALUEEDISCRETEEXCLUDELIST;
  const groupByList = preparedDataAggregation?.length > 0 ? getAggreListHeatMap(preparedDataGroupBy) : AGGREGATIONDATALIST;
  console.log('ss', userInputData, signalList)
  const timeSeriesSignals = dataType === 'raw' ? userInputData : signalList;

  const filtersData = getFilterKeyData(linkCdadMapFilterAttributes?.mapView_data);

  return (
    <Box>
      <SelectAnalysisType analysisType={analysisValue} setAnalysisType={setAnalysisValue} signalList={signalList} />
      {(!prepDataExist || prepDataExist?.length === 0) && analysisValue !== 'timeseries' && analysisValue !== 'scatterPlot' &&
        <Box
          flex={1}
          my={2}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          bgcolor={'#D9D9D9'}
          height={'150px'}
          padding={'16px'}
        >
          <Typography
            variant="caption"
            textAlign={"center"}
            color={theme.palette.text.disabled}
            fontWeight={"bold"}
            width={350}
            fontSize={'1.5rem'}
            textTransform={'capitalize'}
          >
            Use Create Fill Job to analyse in available data chart!
          </Typography>
        </Box>}
        {(analysisValue === 'scatterPlot' || analysisValue === 'timeseries' || analysisValue === 'piechart' || analysisValue === 'barchart') && 
          <div style={{display: 'flex', justifyContent:'flex-end'}}>
            <div
              style={{
                display: "inline-block",
                marginBottom: "10px",
                marginRight: "10px",
                cursor: 'pointer',
              }}
              onClick={handleMapViewClick}
            >
              <MapViewSVG />
            </div>
          </div>
        }
        <Dialog open={isPopupOpen} onClose={handleClosePopup}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <DialogTitle style={{padding: '8px 24px'}}>Map View</DialogTitle>
            <DialogActions>
              <Button onClick={handleClosePopup} color="primary">
                Close
              </Button>
            </DialogActions>
          </div>
          <DialogContent style={{ width: '100%', minWidth: '600px' }}>
            {/* <DataMapVisualization filteredVinListData={filteredVinListData} headerJobId={props.headerJobId} selectedVINs={selectedVINs} jobDetails={jobDetails} expanded={'panel5'} /> */}
              {linkCdadMapFilterAttributes?.isLoading && !linkCdadMapFilterAttributes?.error &&
                <div className={style.overlay}>
                <div className={style.loader}></div>
              </div>
              }
              {/* {linkCdadMapFilterAttributes?.mapView_data && <Geofence style={{height: '315px'}} updateCoordinates={updateCoordinates} updateBond={updateBondValue} onChangeLatLang={setisLatLangNotValid} mapData={filteredMapData} mapDataPoints={getLatLongPositionData(filteredMapData)} filtersData={filtersData} showRangeButtons={false} showLatLongEntry={false} allowMarkerCreation={false} />} */}
              {<Geofence style={{height: '315px'}} updateCoordinates={updateCoordinates} updateBond={updateBondValue} onChangeLatLang={setisLatLangNotValid} mapData={linkCdadMapFilterAttributes?.mapView_data || []} mapDataPoints={getLatLongPositionData(linkCdadMapFilterAttributes?.mapView_data)} filtersData={filtersData} showRangeButtons={false} showLatLongEntry={false} allowMarkerCreation={false} />}
          </DialogContent>
        </Dialog>
      {(prepDataExist?.length > 0 || analysisValue === 'timeseries' || analysisValue === 'scatterPlot' ) && <Box
        sx={{
          display: {
            md: "flex",
            sm: "flex",
            xs: "none",
          },
        }}
        alignItems={"center"}
      >
        <Box flex={1} display={'flex'} flexDirection={"row"} justifyContent={"space-between"} alignItems={'center'}>
          <div><Typography fontWeight={"bold"}>
            {AnalysisTypeList.filter((item: any) => { return (item.id === analysisValue) })[0]?.label}
          </Typography>
          </div>
          <div style={{ display: 'flex', flexDirection: "row", width: '40%' }} >
            {(analysisValue === 'histogram' || analysisValue === 'doubleplot' || analysisValue === 'quadplot' || analysisValue === 'barchart' || analysisValue === 'piechart') &&
              <div>
                <FormControl
                  style={{ width: 'auto', minWidth: '14rem' }}
                >
                  {signalList?.length > 0 && <MultiSelectAutoComplete
                    items={autoCompleteSelectOptionsFormat(signalList)}
                    label="Select / Search Channels"
                    selectAllLabel="Select All"
                    onChange={(value: listItemProp[]) => {
                      // if (value?.length > 0) handleSignalSelection(value)
                      handleSignalSelection(value)
                    }}
                    ref={childRef}
                  />}
                </FormControl>
              </div>
            }
            {(analysisValue === 'barchart' || analysisValue === 'piechart') && <FormControl
              style={{ width: '10rem' }}
            >
              <InputLabel htmlFor="grouped-native-select">Group By</InputLabel>
              <Select
                id="modelSelect"
                value={groupBy}
                MenuProps={{ disablePortal: true }}
                onChange={(event) => {
                  const {
                    target: { value },
                  } = event;
                  setGroupBy(
                    typeof value === 'string' ? value.split(',') : value,
                  );
                }}
                renderValue={(selected) => selected.join(', ')}
                input={<OutlinedInput label="Group By" />}
              >
                {groupByList?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item.value}>
                    <Checkbox checked={groupBy.indexOf(item?.value) > -1} />
                    <ListItemText style={{ textTransform: 'capitalize' }} primary={item.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
            {(analysisValue === 'histogram' || analysisValue === 'doubleplot' || analysisValue === 'quadplot' || analysisValue === 'barchart' || analysisValue === 'piechart') && <FormControl
              style={{ width: '10rem' }}
            >
              <InputLabel htmlFor="grouped-native-select">Aggregate</InputLabel>
              <Select
                id="modelSelect"
                value={aggregateType}
                MenuProps={{ disablePortal: true }}
                onChange={(event) => {
                  const {
                    target: { value },
                  } = event;
                  setAggregateType(
                    typeof value === 'string' ? value.split(',') : value,
                  );
                }}
                renderValue={(selected) => selected.join(', ')}
                input={<OutlinedInput label="Aggregate" />}
              >
                {aggregateList?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item.value}>
                    <Checkbox checked={aggregateType.indexOf(item?.value) > -1} />
                    <ListItemText style={{ textTransform: 'capitalize' }} primary={item.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>}
          </div>
          {((analysisValue === 'barchart' || analysisValue === 'piechart')  || (showApply)) && <div>
            <Button
              variant="contained"
              onClick={() => onApply()}
              disabled={singnalListData?.length === 0 || (groupBy?.length === 0 && (analysisValue === 'barchart' || analysisValue === 'piechart')) || aggregateType?.length === 0}
            >
              APPLY
            </Button>
          </div>}
          <div className='dataypeSelect' style={{ display: 'flex', flexDirection: 'row' }}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue={dataType}
            >
              <FormControlLabel value="raw" onClick={() => { setDataType('raw'); }} control={<Radio />} label="RAW DATA" />
              {prepDataExist?.length > 0 && <FormControlLabel value="fill" onClick={() => { setDataType('fill'); }} control={<Radio />} label="PREPARED DATA" />}
            </RadioGroup>
          </div>

        </Box>
      </Box>}
      {((analysisValue === 'histogram' && prepDataExist?.length > 0 && singnalListData?.length === 0) || (analysisValue === 'doubleplot' && prepDataExist?.length > 0 && singnalListData?.length < 2) || (analysisValue === 'quadplot' && prepDataExist?.length > 0 && singnalListData?.length < 3)) &&
        <Box
          flex={1}
          my={2}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
        >
          <HistogramIcon />
          <Typography
            variant="caption"
            textAlign={"center"}
            color={theme.palette.text.disabled}
            fontWeight={"bold"}
            width={350}
          >
            Use the Above Signal/Channel from dropdowns to analyse in histogram data chart!
          </Typography>
        </Box>}
      {analysisValue === 'histogram' && prepDataExist?.length > 0 && singnalListData?.length > 0 && <HistogramVisualization data={histoGramData} signalListData={singnalListData} setAggregateList={setaggregateList} />}
      {analysisValue === 'doubleplot' && prepDataExist?.length > 0 && singnalListData?.length >= 2 && <DoublePlotHistogramVisualization data={data} signalListData={singnalListData} setAggregateList={setaggregateList} />}
      {analysisValue === 'quadplot' && prepDataExist?.length > 0 && singnalListData?.length >= 4 && <QuadPlotHistogramVisualization data={data} signalListData={singnalListData} setAggregateList={setaggregateList} />}
      {analysisValue === 'barchart' && prepDataExist?.length > 0 && <BarchartDataVisualization userInputData={signalList} updateBarChartFilter={updateBarChartFilter} aggregateType={aggregateType} signalList={singnalListData} groupBy={groupBy} setSelectedVinListVisualization={handleVINSelection} />}
      {analysisValue === 'timeseries' && <TimeSeriesVisualization jobDetails={jobDetails} headerJobId={props.headerJobId} vinListTimeSeries={vinListTimeSeries} updateTimeSeriesFilter={updateTimeSeriesFilter} singnalListData={singnalListData} userInputData={timeSeriesSignals} requestTimeListTimeSeries={requestTimeListTimeSeries} setSelectedVinListVisualization={handleVINSelection} selectedVINs={selectedVINs} />}
      {analysisValue === 'heatmap' && prepDataExist?.length > 0 && <HeatMapVisualization updateHeatMapFilter={updateHeatMapFilter} userInputData={signalList} aggregateType={aggregateType} setAggregateList={setaggregateList} />}
      {analysisValue === 'piechart' && prepDataExist?.length > 0 && <PieChartVisualization updatePieChartFilter={updatePieChartFilter} userInputData={signalList} signalList={singnalListData} groupBy={groupBy} aggregateType={aggregateType} setSelectedVinListVisualization={handleVINSelection} />}
      {analysisValue === 'scatterPlot' && <ScatterPlotVisualization jobDetails={jobDetails} headerJobId={props.headerJobId} updateScatterPLotFilter={updateScatterPLotFilter} vinListTimeSeries={vinListTimeSeries} signalList={signalList} groupBy={groupByList} aggregateType={aggregateList} setSelectedVinListVisualization={handleVINSelection} selectedVINs={selectedVINs} />}
    </Box>
  );
};

export default DataVisualization;  